import moment from "moment";
import { Link } from "react-router-dom";
import { Tooltip } from "react-tooltip";

import siteConfig from "../../../diabete";

import TutoSpeechBubble from "../../../../components/TutoSpeechBubble";

const columns = ({ tutoMode, handleDocument }) => {
  const fileTypes = siteConfig.medias.intervention.models;
  return [
    {
      name: (
        <>
          Statut Ordo.
          <img
            src={siteConfig.medias.renewal.default.path}
            className="w-8 h-8 p-1"
            alt={siteConfig.medias.renewal.default.alt}
            style={{
              position: "absolute",
              zIndex: 50,
              bottom: -45,
              visibility: tutoMode ? "visible" : "hidden",
            }}
          />
          <TutoSpeechBubble
            text="Cet icône permet d'identifier les patients ayant au moins une prescription en renouvellement."
            position={{ top: "250%", left: "70%" }}
            isVisible={tutoMode}
            pointType="default"
            pointPlacement="top-left"
          />
          <img
            src={siteConfig.medias.renewal.late.path}
            className="w-8 h-8 p-1"
            alt={siteConfig.medias.renewal.default.alt}
            style={{
              position: "absolute",
              zIndex: 50,
              bottom: -210,
              visibility: tutoMode ? "visible" : "hidden",
            }}
          />
          <TutoSpeechBubble
            text="Cet icône permet d'identifier les patients ayant au moins une prescription en retard de renouvellement."
            position={{ top: "615%", left: "70%" }}
            isVisible={tutoMode}
            pointType="default"
            pointPlacement="top-left"
          />
        </>
      ),
      sortable: false,
      width: "70px",
      cell: (row) => (
        <div className="flex items-center justify-center w-full gap-1">
          {row.renewal && row.renewal.hasRenewal ? (
            <>
              <img
                src={
                  siteConfig.medias.renewal[
                    row.renewal.hasLate ? "late" : "default"
                  ].path
                }
                className={`h-5 w-5 ${tutoMode ? "blur-lg" : ""}`}
                data-tooltip-id={`renewal_${row._id}`}
                data-tooltip-content={
                  !row.renewal.hasLate
                    ? "Ordonnance à renouveler"
                    : "Ordonnance en retard "
                }
                data-tooltip-place="left"
                alt={
                  siteConfig.medias.renewal[
                    row.renewal.hasLate ? "late" : "default"
                  ].alt
                }
              />
              <Tooltip id={`renewal_${row._id}`} />
            </>
          ) : null}
        </div>
      ),
    },
    {
      name: "Patient",
      selector: (row) => `${row.fullName}`,
      sortable: true,
      sortfield: "lastName",
      width: "200px",
      cell: (row) => (
        <a
          href={`patients/${row._id}`}
          target="_blank"
          rel="noreferrer"
          className={`text-primary font-semibold hover:text-light focus:text-light ${
            tutoMode ? "blur" : null
          }`}
        >
          <span>{`${row.lastName} ${row.firstName}`}</span>
        </a>
      ),
    },
    {
      name: "Prescripteur",
      selector: (row) => `${row.prescriber}`,
      sortable: true,
      sortfield: "prescriber",
      width: "150px",
      cell: (row) => (
        <span
          data-tag="allowRowEvents"
          className={`${tutoMode ? "blur" : null}`}
        >
          {row.prescriber}
        </span>
      ),
    },
    {
      name: (
        <>
          Installation
          <TutoSpeechBubble
            text="Toutes les colonnes peuvent être triées de A>Z ou Z>A."
            position={{ bottom: "-150%", left: "80%" }}
            isVisible={tutoMode}
            pointType="default"
            pointPlacement="top-left"
          />
        </>
      ),
      selector: (row) => `${row.firstContract.startDate}`,
      sortable: true,
      sortfield: "firstContract.startDate",
      width: "118px",
      cell: (row) => (
        <span
          data-tag="allowRowEvents"
          className={`${tutoMode ? "blur" : null}`}
        >
          {row.firstContract?.startDate
            ? moment(row.firstContract.startDate).format("DD/MM/YYYY")
            : ""}
        </span>
      ),
    },
    {
      name: "Dernière int.",
      selector: (row) =>
        `${
          row.lastIntervention && moment.isDate(row.lastIntervention.date)
            ? moment(row.lastIntervention.date).format("DD/MM/YYYY")
            : null
        }`,
      sortable: true,
      sortfield: "lastIntervention.date",
      width: "127px",
      cell: (row) => (
        <span
          data-tag="allowRowEvents"
          className={`${tutoMode ? "blur" : null}`}
        >
          {row.lastIntervention
            ? moment(row.lastIntervention.date).format("DD/MM/YYYY")
            : null}
        </span>
      ),
    } /*
  {
    name: "Prochain suivi",
    selector: (row) => null,
    sortable: true,
    width: "120px",
    cell: (row) => <span data-tag="allowRowEvents">-</span>,
  },*/,
    {
      name: "HbA1c (%)",
      selector: (row) =>
        `${
          row.lastIntervention && row.lastIntervention.metrics
            ? row.lastIntervention.metrics.HbA1c
            : null
        }`,
      sortable: true,
      sortfield: "lastIntervention.metrics.HbA1c",
      width: "114px",
      cell: (row) => (
        <span
          data-tag="allowRowEvents"
          className={`${tutoMode ? "blur" : null}`}
        >
          {row.lastIntervention && row.lastIntervention.metrics
            ? row.lastIntervention.metrics.HbA1c
            : null}
        </span>
      ),
    },
    {
      name: "Pompe",
      selector: (row) => `${row.pump ? row.pump.model : null}`,
      sortable: true,
      sortfield: "pump.model",
      cell: (row) => (
        <span
          data-tag="allowRowEvents"
          className={`${tutoMode ? "blur" : null}`}
        >
          {row.pump && typeof row.pump.model === "string"
            ? row.pump.model.replace("POMPE ", "")
            : null}
        </span>
      ),
    },
    {
      name: "Capteur",
      selector: (row) =>
        `${
          row.lastIntervention && row.lastIntervention.sensorType
            ? row.lastIntervention.sensorType
            : null
        }`,
      sortable: true,
      sortfield: "lastIntervention.sensorType",
      cell: (row) => (
        <span
          data-tag="allowRowEvents"
          className={`${tutoMode ? "blur" : null}`}
        >
          {" "}
          {row.lastIntervention && row.lastIntervention.sensorType
            ? row.lastIntervention.sensorType.replaceAll('"', "")
            : null}
        </span>
      ),
    },
    {
      name: "TIR (%)",
      selector: (row) =>
        `${
          row.lastIntervention && row.lastIntervention.metrics
            ? row.lastIntervention.metrics.tir
            : null
        }`,
      sortable: true,
      sortfield: "lastIntervention.metrics.tir",
      width: "95px",
      cell: (row) => (
        <span
          data-tag="allowRowEvents"
          className={`${tutoMode ? "blur" : null}`}
        >
          {" "}
          {row.lastIntervention && row.lastIntervention.metrics
            ? row.lastIntervention.metrics.tir
            : null}
        </span>
      ),
    } /*
  {
    name: "CV",
    selector: (row) =>
      `${
        row.lastIntervention && row.lastIntervention.metrics
          ? row.lastIntervention.metrics.cv
          : null
      }`,
    sortable: true,
    sortfield: "lastIntervention.metrics.cv",
    width: "90px",
    cell: (row) => (
      <span data-tag="allowRowEvents">
        {" "}
        {row.lastIntervention && row.lastIntervention.metrics
          ? row.lastIntervention.metrics.cv
          : null}
      </span>
    ),
  },*/,
    {
      name: (
        <span>
          CR non lu
          <img
            src={siteConfig.medias.intervention.documents.Courrier.path}
            className="w-8 h-8 p-1 ml-5"
            alt={siteConfig.medias.intervention.documents.Courrier.alt}
            style={{
              position: "absolute",
              zIndex: 50,
              bottom: -45,
              visibility: tutoMode ? "visible" : "hidden",
            }}
          />
          <TutoSpeechBubble
            text="Cet icône permet d’accéder directement au dernier compte-rendu non consulté du patient concerné."
            position={{ top: "270%", right: "65%" }}
            isVisible={tutoMode}
            pointType="default"
            pointPlacement="top-right"
          />
        </span>
      ),
      sortable: false,
      sortField: null,
      width: "88px",
      cell: (row) => {
        if (
          Array.isArray(row.lastIntervention?.documents) &&
          row.lastIntervention?.documents?.length > 0
        ) {
          const filterDocs = row.lastIntervention.documents
            .filter((doc) => doc.importType === "Courrier")
            .sort((prevDoc, currentDoc) => {
              return moment(currentDoc.date._d).isAfter(prevDoc.date._d);
            });
          const doc =
            filterDocs.length > 0 && !filterDocs[0].firstReader
              ? filterDocs[0]
              : null;
          if (doc) {
            const docName = process.env.REACT_APP_DEMO
              ? fileTypes[doc.importType]
                ? fileTypes[doc.importType].name
                : fileTypes.default.name
              : doc.name;
            if (doc.extension === "pdf") {
              return (
                <Link
                  key={`Cdoc_${doc.id}`}
                  to={`/file/intervention/${row.lastIntervention._id}?doc=${
                    doc.id
                  }${
                    process.env.REACT_APP_DEMO ? "&type=" + doc.importType : ""
                  }`}
                  target="_blank"
                  data-tip={docName}
                  className={`flex flex-1 justify-center ${
                    tutoMode ? "blur" : null
                  }`}
                >
                  <img
                    src={siteConfig.medias.intervention.documents.Courrier.path}
                    className="p-1"
                    alt="download"
                    width={33}
                    height={33}
                    data-tooltip-id={`doc_${doc.id}`}
                    data-tooltip-content={docName}
                    data-tooltip-place="left"
                  />
                  <Tooltip id={`doc_${doc.id}`} />
                </Link>
              );
            } else {
              return (
                <div
                  key={`Cdoc_${doc.id}`}
                  data-tip={docName}
                  className={`flex flex-1 justify-center cursor-pointer ${
                    tutoMode ? "blur" : null
                  }`}
                >
                  <img
                    src={siteConfig.medias.intervention.documents.Courrier.path}
                    className="p-1"
                    alt="download"
                    width={33}
                    height={33}
                    data-tooltip-id={`doc_${doc.id}`}
                    data-tooltip-content={docName}
                    data-tooltip-place="left"
                    onClick={async () => {
                      if (!process.env.REACT_APP_DEMO) {
                        await handleDocument(
                          "intervention",
                          row.lastIntervention._id,
                          doc.id
                        );
                      } else {
                        window.open(
                          `/file/intervention/${row.lastIntervention._id}?doc=${
                            doc.id
                          }${
                            process.env.REACT_APP_DEMO
                              ? "&type=" + doc.importType
                              : ""
                          }`,
                          "_blank"
                        );
                      }
                    }}
                  />
                  <Tooltip id={`doc_${doc.id}`} />
                </div>
              );
            }
          } else {
            return null;
          }
        }
      },
    },
  ];
};

export default columns;
